// extracted by mini-css-extract-plugin
export default {"sendToApproveModal":"styles_send-to-approve-modal__3kr7p","sendToApproveModal__formItem":"styles_send-to-approve-modal__form-item__7qazA"};